// src/services/staffApi.js
// API client for vendor STAFF sessions (cashier / manager).
// Deliberately separate from the shared `api` instance: that one sends cookies
// (withCredentials), and the backend prefers the owner cookie over a Bearer
// header — so a staff request through it could silently run as the owner.
// This client sends the staff Bearer token only and never cookies.

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const KEY     = 'qs_staff_session';

const staffApi = axios.create({ baseURL: API_URL, withCredentials: false });

// sessionStorage: cleared when the tab closes (shared tills). Every access is
// guarded — storage can be unavailable (private mode, blocked site data).
export const getStaffSession = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { return null; }
};
export const saveStaffSession = (s) => { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (_) {} };
export const clearStaffSession = () => { try { sessionStorage.removeItem(KEY); } catch (_) {} };

staffApi.interceptors.request.use((config) => {
  const s = getStaffSession();
  if (s?.token) config.headers.Authorization = `Bearer ${s.token}`;
  return config;
});

export const staffLogin = (email, password) => staffApi.post('/auth/staff/login', { email, password });

export default staffApi;
